<template>
  <div class="toggle-selector">
    <div @click="selectNone" class="toggle-selector__item">
      Select None
    </div>
    <div @click="selectAll" class="toggle-selector__item">
      Select All
    </div>
  </div>
</template>

<script>
  export default {
    name: 'treeselect-toggle-all-selector',
    methods: {
      selectAll() {
        this.$emit('select-all');
      },

      selectNone() {
        this.$emit('select-none');
      },
    },
  }
</script>
